// extracted by mini-css-extract-plugin
module.exports = {"header":"FavoritesPage_header__2hmft","head":"FavoritesPage_head__WY4TR","grid":"FavoritesPage_grid__1uAUq"};